import moment from 'moment-jalaali';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Award, GitCommit, X } from 'tabler-icons-react';
import { setSelectedMarker } from 'Actions';
import { Names, slugify, clx } from 'Utils';
import { Avatar, Button } from 'Elements';
// import Placeholder from 'assets/img/img-user-default.png';
import styles from 'partials/dashboard/story-card.module.scss';

export const StoryCard = ({ story, onClose }) => {
	const dispatch = useDispatch();

	const handleClick = () => {
		dispatch(setSelectedMarker(story));
	};

	return (
		<div className={styles.card}>
			{/* <img
				src={story.avatar ?? Placeholder}
				alt={story.title}
				className={styles.image}
			/> */}
			<div className={styles.content}>
				<h3
					role="presentation"
					className={styles.title}
					onClick={handleClick}
					onKeyPress={handleClick}>
					<Link
						to={`${Names.story.path}/${story.id}/${slugify(
							story.slug
						)}`}>
						<span>{story.title}</span>
					</Link>
				</h3>
				<div className={styles.meta}>
					<div className={styles.avatars}>
						{story.persons.slice(0, 5).map((elem) => {
							return (
								<Avatar
									key={elem.id}
									alt={elem.full_name}
									src={elem.avatar}
									className={styles.avatar}
								/>
							);
						})}
						{story.persons.length > 5 && (
							<div className={styles.avatarCounter}>
								+{story.persons.length - 5}
							</div>
						)}
					</div>
					<span className={styles.metaText}>
						{story.location.city.name}
					</span>
					<span className={styles.metaText}>
						{moment.unix(story.start_date).format('jYYYY')}
					</span>
					<div className={styles.icons}>
						{story.is_verify === 1 && (
							<Award
								className={clx(styles.icon, styles.iconBadge)}
							/>
						)}
						{story.is_section === 1 && (
							<GitCommit
								className={clx(styles.icon, styles.iconSeq)}
							/>
						)}
					</div>
				</div>
			</div>
			<Button className={styles.close} onClick={onClose}>
				<X size="22" className={styles.closeIcon} />
			</Button>
		</div>
	);
};
